export const IS_SHOWROOM = (ENV_TAGS || []).indexOf("Showroom") >= 0; //webpack.DefinePlugin

export default {
  //fields
  name: "Name",
  retailPrice: "MSRP",
  upc: "UPC",
  category: "Category",
  type: "Type",
  design: "Design Tags",
  description: "CompanyName",
  SalesPrice: "Sales Price",
  ListPrice: "List Price",
  ExtendedTotal: "Ext. Total",
  DontMaskPhone: true,
  AccountType: "Account Type",
  StoreType: "Store Type",
  Territory: "Territory",
  Region: "Region",
  //UserFieldset
  fullName: "Full Name",
  userName: "User Name",
  displayName: "Display Name",
  email: "Email",
  primaryEmail: false,
  password: "Password",
  phoneNummber: "Phone",
  role: "Role(s)",
  shard: false,
  vendor: "Vendor",
  birthDate: "Birth Date",
  company: "Company",
  retailer: "Retailer",
  salesRepid: "Rep",
  region: "Region",
  tags: "Tags",
  bio: "Bio",
  createdDate: "Created",
  lastLoginAttempt: "Last Login",
  lockedDate: "Locked",
  shard: false, //"Vendor",
  msrpMultiplier: "Multiplier (Cost x Multiplier)",
  useMsrp: "Provided MSRP",
  limitProducts:
    "Limit Products (user will be limited to products selected under 'My Products'",
  dealerPricing: "Dealer Pricing (Dealer Pricing is set under 'My Products')",

  //actions
  //addUser: IS_SHOWROOM ? "" : "Add User",
  addUser: "Add User",
  callUser: "Click to call...",
  //  editUser: !IS_SHOWROOM && "Edit User...",
  editUser: "Edit User...",
  syncUsers: IS_SHOWROOM ? "Sync Users..." : "",
  lockUser: !IS_SHOWROOM && "Lock User",
  unlockUser: "Unlock User",
  impersonate: "Impersonate User",
  deleteUser: !IS_SHOWROOM && "Delete User",
  resetPassword: "Reset Password",
  changePassword: "Change Password",
  marketingProfile: false
};
